<p-table #workflow [columns]="listCols" [value]="workflowListResults"
    selectionMode="single" [(selection)]="selectedWorkflow" dataKey="id" responsiveLayout="scroll"
    (onRowSelect)="onRowSelect($event);"
    (onRowUnselect)="onRowUnselect($event)"
    [lazy]="true" (onLazyLoad)="getWorkflowListByFilter($event)"
    [paginator]="true" [rows]="pageSize" [totalRecords]="totalRecords" [(first)]="first"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="tableShowMore"
    styleClass="p-datatable-gridlines" [resizableColumns]="true" [style]="{width:'100%'}">

    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
            <th *ngIf="col.show" [pSortableColumn]="col.field"
            style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
                <span *ngIf="col.order" class="pi pi-filter p-ml-2 filtericon"
                    [ngClass]="{'blink_me' : col.value.length > 0}"
                    (click)="$event.stopPropagation(); curCol = col; op.toggle($event)">
                </span>
            </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
            <ng-container *ngFor="let col of columns">
                <td *ngIf="col.show" style="text-align: left;">
                    <ng-container [ngSwitch]="col?.dataType">
                        <ng-container *ngSwitchCase="'date'">
                            {{ rowData[col.field] | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'string'">
                            {{ rowData[col.field] }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="9">{{noWfFindOrLoadingText}}</td>
        </tr>
    </ng-template>
</p-table>
<p-overlayPanel #op [showCloseIcon]="false" [dismissable]="true">
    <ng-template pTemplate>
        <input pInputText type="text" #inputS [(ngModel)]="curCol.value"
        (input)="workflow.filter(curCol.value, curCol.field, 'contains')"
        placeholder="Search by {{curCol.header}}" class="p-column-filter"
        [value]="workflow.filters[curCol.field] ? workflow.filters[curCol.field].value : ''">
    </ng-template>
</p-overlayPanel>

<p-dialog header="Mass Edit Details" [(visible)]="displayHistoryDetails" (onHide)="historyDialogClose()" [modal]="true" [responsive]="true" [style]="{ width: '60vw' }">
    <div class="card">
        <div class="header p-d-flex p-jc-between" style="position: relative; height: 43px;">
            <h5 class="p-mt-2">Triggered By Condition</h5>
        </div>
        <ng-container *ngTemplateOutlet="conditionDetailsTemplate; context: { conditionGroupDetails: historyConditionGroup, workflowDetailsView: false }"></ng-container>

        <div class="header p-d-flex p-jc-between" style="position: relative; height: 43px;margin-top: 25px;">
            <h5 class="p-mt-2">Affected

                <ng-container [ngSwitch]="workflowDetails?.objectName">
                    <ng-container *ngSwitchCase="'Opportunity'">
                        Opportunities
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ workflowDetails?.objectName+'s' }}
                    </ng-container>
                </ng-container>

                <span>({{actionHistoryResults?.length||0}})</span>
            </h5>
        </div>

        <div style="padding: 10px;margin-top: 15px;">
            <p-table [value]="actionHistoryResults" [columns]="selectedDetailsCols" responsiveLayout="scroll" styleClass="p-datatable-gridlines">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="col.show" style="min-width: 100px;">
                                {{col.header}}
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                        <ng-container *ngFor="let col of columns">
                            <td *ngIf="col.show" style="text-align: left;min-width: 100px;">
                                <ng-container [ngSwitch]="col?.dataType">
                                    <ng-container *ngSwitchCase="'date'">
                                        <div>
                                            {{ rowData[col.field] | localDate:'MM/DD/YYYY | h:mm a' }}
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'string'">
                                        <span class="saved-search-popup-link" style="word-break: break-word;" *ngIf="['name'].includes(col?.value?.toLowerCase())" (click)="onRouteNavigation(rowData,col.field,col.name)">
                                            {{ rowData[col.field] }}
                                        </span>
                                        <span [pTooltip]="rowData[col.field]" style="word-break: break-word;" *ngIf="!(['name'].includes(col?.value?.toLowerCase()))">
                                            {{ rowData[col.field] | shorten:50 }}
                                        </span>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <span [pTooltip]="rowData[col.field]">{{ rowData[col.field] | shorten:50 }}</span>
                                    </ng-container>
                                </ng-container>
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" style="text-align: center">No Data Found!</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </div>
    <p-footer>
        <button type="button" pButton (click)="historyDialogClose()" label="Close" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<!-- Condition Details Start -->
<ng-template #conditionDetailsTemplate let-conditionGroupDetails="conditionGroupDetails" let-workflowDetailsView="workflowDetailsView">
    <div class="card" *ngIf="workflowDetails">
        <ng-container *ngFor="let addedCondition of conditionGroupDetails|statusFilter:true; let i = index;">
            <p-panel [toggleable]="true" [iconPos]="left" class="condition-details row-reverse">
                <ng-template pTemplate="header">
                    <div class="p-d-flex w-100 p-pl-3">
                        <h6 class="p-mb-0 p-mt-2" style="flex-grow: 1;">
                            Condition {{ addedCondition?.conditionNumber }} ({{ selectedWorkflow?.ruleType == 1 ? 'Rule Logic' : 'Manual Selection' }})

                            <span *ngIf="!addedCondition?.validData && addedCondition?.errorMsg" class="p-invalid pml-3"><small>{{ addedCondition.errorMsg }}</small></span>
                        </h6>
                    </div>
                </ng-template>
                <ng-container>
                    <div *ngIf="addedCondition?.ruleData?.length > 0" class="p-field p-grid">
                        <div class="p-col-12">
                            <app-saved-search-added-rules-table
                                [isDisabled]="true"
                                [ruleData]="addedCondition.ruleData"
                                [ruleCombination]="addedCondition.ruleCombination"
                                [isCombinational]="addedCondition.isCombinational">
                            </app-saved-search-added-rules-table>
                        </div>
                    </div>

                    <div *ngIf="addedCondition?.instantActions" class="header p-d-flex p-jc-between" style="position: relative; height: 43px;">
                        <h5 class="p-mt-2">Updated Fields</h5>
                    </div>

                    <div class="card" *ngIf="addedCondition?.instantActions">
                        <p-table *ngIf="checkActions(addedCondition?.instantActions)">
                            <ng-template pTemplate="header">
                            <tr>
                                <th class="workflow-action-type">Action Type</th>
                                <th style="width: auto">Description</th>
                            </tr>
                            </ng-template>
                        </p-table>

                        <div>
                            <ng-container *ngFor="let actionOrder of addedCondition?.instantActions?.executionOrders">
                                <div *ngIf="addedCondition?.instantActions?.[actionOrder.code]?.length>0">
                                    <div class="action-list-wrapper">
                                        <!-- <h6 class="drag-section-label">
                                            <i class="pi pi-bars p-mr-3" style="color: lightgray"></i>{{actionOrder.name}}
                                        </h6> -->
                                        <div *ngIf="!actionOrder?.collapsed && !addedCondition?.instantActions?.hideContent">
                                            <ng-container [ngSwitch]="actionOrder.code">
                                                <ng-container *ngSwitchCase="'workflowActionUpdateFields'">
                                                    <p-table [value]="addedCondition?.instantActions?.workflowActionUpdateFields">
                                                        <ng-template pTemplate="body" let-fieldDetails let-index="rowIndex">
                                                            <tr>
                                                                <td class="workflow-action-type">Update Field ({{fieldDetails?.objectName}})</td>
                                                                <td style="width: auto">Field: <strong>{{ fieldDetails?.labelName||fieldDetails.fieldName }}</strong> | {{ fieldDetails?.operationType | workflowUFOT }} Value: <strong>{{ fieldDetails | wfUFValue | removeHtmlTags | shorten }}</strong></td>

                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <ng-container *ngIf="!checkActions(addedCondition?.instantActions)">
                            <div class="p-text-center p-y-2">No Fields Added!</div>
                        </ng-container>
                    </div>
                </ng-container>
            </p-panel>
        </ng-container>
    </div>
</ng-template>
<!-- Condition Details End -->

<!-- Account Edit Component -->
<app-edit-account *ngIf="displayAccountViewEdit"
    [displayEditViewDialog]="displayAccountViewEdit"
    [displayView]="true"
    [selectedAccountId]="selectedAccountId"
    (closeModal)="closeViewPopup()">
</app-edit-account>

<!-- Lead View/Edit -->
<app-add-update-view-lead *ngIf="displayLeadViewEdit" [display]="true"
    [selectedLeadId]="selectedLeadId"
    [crudType]="'view'"
    (cancelClicked)="closeViewPopup()">
</app-add-update-view-lead>

<!-- Opportunity View/Edit -->
<app-opportunity-add-edit-dialog *ngIf="displayOpportunityViewEdit"
    [displayAddEditDialog]="displayOpportunityViewEdit" [accountChannelId]="workflowDetails?.accountChannelId"
    [opportunityId]="opportunityEditViewId" [crudType]="'view'"
    (closeModal)="closeViewPopup()">
</app-opportunity-add-edit-dialog>
